import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs';

import { PortalOrderService } from '@app/services/portal-order/portal-order.service';
import { PortalQueryParams, PortalRoutes } from '@app/app-routing.module';

@Injectable({
  providedIn: 'root',
})
export class PortalOrderPageGuard {
  constructor(
    private portalOrderService: PortalOrderService,
    private router: Router,
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot) {
    return this.portalOrderService.portalOrder$.pipe(
      map((portalOrder) => {
        if (portalOrder) {
          return true;
        }

        const portalLink = route.parent?.parent?.paramMap.get('lead-id') || '';
        const utmSource =
          route.parent?.parent?.queryParamMap.get(PortalQueryParams.UtmSource) || '';
        const queryParams: Record<string, string> = {};

        if (utmSource) {
          queryParams[PortalQueryParams.UtmSource] = utmSource;
        }

        void this.router.navigate([portalLink ? `${portalLink}` : PortalRoutes.NotFound], {
          queryParams,
        });

        return false;
      }),
    );
  }
}
